import React from 'react'

function TenderTextGaslight() {
  return (
    <embed src="\pdfs\EA2.1.1_gd-c_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextGaslight